import { AGENCY } from "@/modules/profile/routes/ProfileRoutes";

export interface AgencyLinkComponentProps {
  agencyId: string | number;
  agencyLabel: string;
}

const AgencyLinkComponent = ({
  agencyId,
  agencyLabel,
}: AgencyLinkComponentProps) => {
  const handleClick = () => {
    const url = `${window.location.origin}${AGENCY.replace(":id", String(agencyId))}?readOnly=true`;
    window.open(url, '_blank');
  };

  return (
    <span
      onClick={handleClick}
      className="cursor-pointer text-gray-900 hover:text-blue-600 transition-colors duration-200"
    >
      {agencyLabel}
    </span>
  );
};

export default AgencyLinkComponent;
